import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import CodeEditor from '../ui/CodeEditor';

/**
 * Pre-request / post-response scripts of a collection or folder page (owner
 * D4, 28.09.2026), in the same editor and sub-tab layout the request uses.
 *
 * WHEN they run is stated, because it differs from a request's own script:
 * `utils/scriptChain` feeds collection → folders → request scripts to Run
 * collection only; a single Send runs only the request's own script. The hint
 * says exactly that and nothing more.
 */
export default function ScriptsSection({ kind, preRequestScript, testScript, onChange, disabled }) {
  const { t } = useTranslation();
  const [sub, setSub] = useState('pre');
  const tabs = [
    { key: 'pre', label: t('request.scriptPre') },
    { key: 'post', label: t('request.scriptPost') },
  ];
  const isPre = sub === 'pre';

  return (
    <div className="script-tab-shell px-5 pt-0 pb-0 h-full flex flex-col min-h-0" data-testid="page-scripts">
      <p className="text-xs text-gray-500 dark:text-zinc-500 pt-2 pb-1" role="note">
        {t(kind === 'folder' ? 'collectionPage.scriptsWhenFolder' : 'collectionPage.scriptsWhenCollection')}
      </p>
      <nav className="script-subtab-bar flex space-x-1 flex-shrink-0">
        {tabs.map(({ key, label }) => (
          <button
            key={key}
            type="button"
            onClick={() => setSub(key)}
            className={`py-0.5 px-2.5 font-medium text-[11px] rounded bg-transparent transition-colors duration-150 ${
              sub === key ? 'text-blue-600' : 'text-gray-500 hover:text-gray-700'
            }`}
          >
            {label}
          </button>
        ))}
      </nav>
      <div className="script-editor-shell flex-1 min-h-0">
        <CodeEditor
          key={sub}
          hideChrome
          value={isPre ? preRequestScript : testScript}
          onChange={(val) => onChange(isPre ? 'preRequestScript' : 'testScript', val)}
          language="javascript"
          readOnly={disabled}
          placeholder={t(isPre ? 'request.preRequestPlaceholder' : 'request.postResponsePlaceholder')}
          height="100%"
        />
      </div>
    </div>
  );
}
